var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowSpininline = function SvgArrowSpininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CB9",
    d: "M23.435 27.405a1.25 1.25 0 0 0-1.407-2.068A12.5 12.5 0 1 1 27.5 15a1.25 1.25 0 0 0 2.5 0 15 15 0 1 0-6.565 12.405Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005CB9",
    d: "M21.922 11.037a1.252 1.252 0 0 0-1.929.825 1.25 1.25 0 0 0 .582 1.28l8.705 5.568a1.248 1.248 0 0 0 1.93-.825 1.252 1.252 0 0 0-.582-1.28l-8.706-5.568Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005CB9",
    d: "M34.867 9.715a1.25 1.25 0 0 0-2.282-1.017l-3.773 8.45a1.252 1.252 0 0 0 2.285 1.02l3.77-8.453Z"
  })));
};
export default SvgArrowSpininline;